export const messages = {
  en: {
    addRoomView: {
      title: 'Add Room',
      building: 'Building',
      unit: 'Unit',
      roomNumber: 'Room Number',
      roomFloor: 'Room Floor',
      roomType: 'Room Type',
      rent: 'Rent',
      builtUpArea: 'Built-up Area (㎡)',
      roomArea: 'Room Area (㎡)',
      feeCoefficient: 'Fee Coefficient',
      roomStatus: 'Room Status',
      owner: 'Owner',
      remark: 'Remark',
      selectOwner: 'Select Owner',
      requiredRoomNumber: 'Required, please enter room number',
      requiredRoomFloor: 'Required, please enter room floor',
      requiredRent: 'Required, please enter rent',
      requiredBuiltUpArea: 'Required, please enter built-up area',
      requiredRoomArea: 'Required, please enter room area',
      requiredFeeCoefficient: 'Required, please enter fee coefficient',
      requiredOwner: 'Required, please select owner',
      optionalRemark: 'Optional, please enter remark',
      notSold: 'Not Sold',
      living: 'Living',
      delivered: 'Delivered',
      decorated: 'Decorated',
      notLived: 'Not Lived',
      decorating: 'Decorating',
      saveSuccess: 'Room added successfully',
      saveError: 'Failed to add room',
      validate: {
        roomNumRequired: 'Room number is required',
        roomNumMaxLength: 'Room number cannot exceed 64 characters',
        layerRequired: 'Room floor is required',
        builtUpAreaRequired: 'Built-up area is required',
        builtUpAreaFormat: 'Invalid built-up area format, e.g. 300.00',
        roomAreaRequired: 'Room area is required',
        roomAreaFormat: 'Invalid room area format, e.g. 300.00',
        feeCoefficientRequired: 'Fee coefficient is required',
        feeCoefficientFormat: 'Invalid fee coefficient format, e.g. 1.00',
        stateRequired: 'Room status is required',
        stateMaxLength: 'Room status cannot exceed 12 characters',
        roomSubTypeRequired: 'Room type is required',
        remarkMaxLength: 'Remark cannot exceed 200 characters'
      }
    },
  },
  zh: {
    addRoomView: {
      title: '添加房屋',
      building: '楼栋',
      unit: '单元',
      roomNumber: '房屋编号',
      roomFloor: '房屋楼层',
      roomType: '房屋类型',
      rent: '租金',
      builtUpArea: '建筑面积(平方)',
      roomArea: '室内面积(平方)',
      feeCoefficient: '算费系数',
      roomStatus: '房屋状态',
      owner: '业主',
      remark: '备注',
      selectOwner: '选择业主',
      requiredRoomNumber: '必填，请填写房屋编号',
      requiredRoomFloor: '必填，请填写房屋楼层',
      requiredRent: '必填，请填写租金',
      requiredBuiltUpArea: '必填，请填写建筑面积',
      requiredRoomArea: '必填，请填写室内面积',
      requiredFeeCoefficient: '必填，请填写算费系数',
      requiredOwner: '必填，请选择业主',
      optionalRemark: '选填，请填写备注',
      notSold: '未销售',
      living: '已入住',
      delivered: '已交房',
      decorated: '已装修',
      notLived: '未入住',
      decorating: '装修中',
      saveSuccess: '房屋添加成功',
      saveError: '房屋添加失败',
      validate: {
        roomNumRequired: '房屋编号不能为空',
        roomNumMaxLength: '房屋编号长度不能超过64位',
        layerRequired: '房屋楼层不能为空',
        builtUpAreaRequired: '建筑面积不能为空',
        builtUpAreaFormat: '建筑面积错误，如 300.00',
        roomAreaRequired: '室内面积不能为空',
        roomAreaFormat: '室内面积错误，如 300.00',
        feeCoefficientRequired: '算费系数不能为空',
        feeCoefficientFormat: '算费系数错误，如 1.00',
        stateRequired: '房屋状态不能为空',
        stateMaxLength: '房屋状态不能超过12位',
        roomSubTypeRequired: '房屋类型不能为空',
remarkMaxLength: '备注内容不能超过200'
      }
    },
  },
  'zh-TW': {
    addRoomView: {
      title: '添加房屋',
      building: '樓棟',
      unit: '單元',
      roomNumber: '房屋編號',
      roomFloor: '房屋樓層',
      roomType: '房屋類型',
      rent: '租金',
      builtUpArea: '建築面積(平方)',
      roomArea: '室內面積(平方)',
      feeCoefficient: '算費係數',
      roomStatus: '房屋狀態',
      owner: '業主',
      remark: '備註',
      selectOwner: '選擇業主',
      requiredRoomNumber: '必填，請填寫房屋編號',
      requiredRoomFloor: '必填，請填寫房屋樓層',
      requiredRent: '必填，請填寫租金',
      requiredBuiltUpArea: '必填，請填寫建築面積',
      requiredRoomArea: '必填，請填寫室內面積',
      requiredFeeCoefficient: '必填，請填寫算費係數',
      requiredOwner: '必填，請選擇業主',
      optionalRemark: '選填，請填寫備註',
      notSold: '未銷售',
      living: '已入住',
      delivered: '已交房',
      decorated: '已裝修',
      notLived: '未入住',
      decorating: '裝修中',
      saveSuccess: '房屋添加成功',
      saveError: '房屋添加失敗',
      validate: {
        roomNumRequired: '房屋編號不能為空',
        roomNumMaxLength: '房屋編號長度不能超過64位',
        layerRequired: '房屋樓層不能為空',
        builtUpAreaRequired: '建築面積不能為空',
        builtUpAreaFormat: '建築面積錯誤，如 300.00',
        roomAreaRequired: '室內面積不能為空',
        roomAreaFormat: '室內面積錯誤，如 300.00',
        feeCoefficientRequired: '算費係數不能為空',
        feeCoefficientFormat: '算費係數錯誤，如 1.00',
        stateRequired: '房屋狀態不能為空',
        stateMaxLength: '房屋狀態不能超過12位',
        roomSubTypeRequired: '房屋類型不能為空',
        remarkMaxLength: '備註內容不能超過200'
      }
    },
  }
}